// React
import React from "react";
import classNames from "classnames";
// Components
import FlexContainer from "common/ui/containers/flexContainer/FlexContainer";
import DataBarLabel from "common/ui/components/dataBar/DataBarLabel";
//-------------------------------------------------------------------------------------------------------------------------------
// Styles
//-------------------------------------------------------------------------------------------------------------------------------
import styles from "./DataBar.less";
const DataBar = ({ label, labelTooltip, children }) => {
    let isJustifyLeft = false;
    if (children) {
        const childrenCount = children.length;
        if (!childrenCount || childrenCount < 2) {
            isJustifyLeft = true;
        }
    }
    return (React.createElement(FlexContainer, { className: classNames(styles.dataBar, isJustifyLeft && styles.dataBarLeftJustify), breakPoint: 10 },
        label && React.createElement(DataBarLabel, { className: styles.dataBarLabel, label: label, toolTip: labelTooltip }),
        React.createElement(FlexContainer, { className: classNames(styles.dataBarItemsContainer, isJustifyLeft && styles.dataBarItemsContainerLeft), breakPoint: 10 }, children)));
};
export default DataBar;
